import type { $Fetch } from 'ofetch';
import type {
  RelatorioInadimplentes, InadimplentesParams,
  RelatorioAdimplentes, AdimplentesParams,
  RelatorioPagamentosPorPolo, PagamentosPorPoloParams,
  RelatorioAcessoAva, AcessoAvaParams,
} from '@/domain/model/Relatorios';
import type { RelatorioGateway } from '@/application/port/out/RelatorioGateway';
import type { ApiResponse } from '@/infrastructure/http/types';
import { assertApiSuccess } from '@/infrastructure/http/assertApiSuccess';

const FIN = '/api/v1/relatorios/financeiro';

/** HTTP gateway dos relatórios. Authorities `commerce:cobranca:read` / `enrollment:aluno:read`. */
export class HttpRelatorioGateway implements RelatorioGateway {
  constructor(private readonly client: $Fetch) {}

  async inadimplentes(p: InadimplentesParams): Promise<RelatorioInadimplentes> {
    const params: Record<string, string | number> = {};
    if (p.courseId) params['courseId'] = p.courseId;
    if (p.statusMatricula) params['statusMatricula'] = p.statusMatricula;
    if (p.diasAtrasoMin != null) params['diasAtrasoMin'] = p.diasAtrasoMin;
    if (p.diasAtrasoMax != null) params['diasAtrasoMax'] = p.diasAtrasoMax;
    const res = await this.client<ApiResponse<RelatorioInadimplentes>>(`${FIN}/inadimplentes`, { method: 'GET', params });
    assertApiSuccess(res); return res.data;
  }

  async adimplentes(p: AdimplentesParams): Promise<RelatorioAdimplentes> {
    const params: Record<string, string> = {};
    if (p.courseId) params['courseId'] = p.courseId;
    if (p.statusMatricula) params['statusMatricula'] = p.statusMatricula;
    if (p.pagamentoDe) params['pagamentoDe'] = p.pagamentoDe;
    if (p.pagamentoAte) params['pagamentoAte'] = p.pagamentoAte;
    const res = await this.client<ApiResponse<RelatorioAdimplentes>>(`${FIN}/adimplentes`, { method: 'GET', params });
    assertApiSuccess(res); return res.data;
  }

  async pagamentosPorPolo(p: PagamentosPorPoloParams): Promise<RelatorioPagamentosPorPolo> {
    const params: Record<string, number> = {};
    if (p.ano != null) params['ano'] = p.ano;
    if (p.mes != null) params['mes'] = p.mes;
    const res = await this.client<ApiResponse<RelatorioPagamentosPorPolo>>(`${FIN}/pagamentos-por-polo`, { method: 'GET', params });
    assertApiSuccess(res); return res.data;
  }

  async acessoAva(p: AcessoAvaParams): Promise<RelatorioAcessoAva> {
    const params: Record<string, string> = {};
    if (p.courseId) params['courseId'] = p.courseId;
    if (p.statusMatricula) params['statusMatricula'] = p.statusMatricula;
    if (p.acessoDe) params['acessoDe'] = p.acessoDe;
    if (p.acessoAte) params['acessoAte'] = p.acessoAte;
    const res = await this.client<ApiResponse<RelatorioAcessoAva>>('/api/v1/relatorios/acesso-ava', { method: 'GET', params });
    assertApiSuccess(res); return res.data;
  }
}
